import { useFlags } from 'launchdarkly-react-client-sdk';
import { DrawerId, useSideDrawer } from 'src/components/containers/SideDrawer';
import { AgButton } from 'src/components/ui';
import AiChatIcon from './AiChatIcon';

export default function AiChatButton() {
  const flags = useFlags();
  const { openDrawer } = useSideDrawer();

  if (!flags.aiChat) {
    return null;
  }

  return (
    <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => openDrawer(DrawerId.AI_CHAT)}>
      <AiChatIcon />
    </AgButton>
  );
}
